import * as React from "react";
import { SVGProps } from "react";
const SvgChartPie = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15 21.91c-2.833-.478-5-2.942-5-5.91s2.167-5.431 5-5.91V5.191a1 1 0 0 0-1.183-.983C8.24 5.238 4 10.129 4 16c0 5.871 4.24 10.763 9.817 11.792A1 1 0 0 0 15 26.808V21.91Zm6.622-8.001c.243.651.378 1.355.378 2.091 0 2.967-2.167 5.431-5 5.91v4.899a1 1 0 0 0 1.183.983C23.76 26.763 28 21.871 28 16c0-1.507-.281-2.95-.791-4.279a1 1 0 0 0-1.479-.48l-4.108 2.668Zm-1.011-1.729 4.112-2.67a1 1 0 0 0 .199-1.508 11.997 11.997 0 0 0-6.739-3.793A1 1 0 0 0 17 5.192v4.898a6.001 6.001 0 0 1 3.423 1.874l.188.216Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChartPie;
